module.exports = __webpack_public_path__ + "media/images/certificates/certificat-01-8919e0a4d60edb0e6b7f496c74cc4294.png";